import $ from 'jquery';
import '../../../node_modules/slick-carousel/slick/slick.js';

$(document).ready(function () {
  const prevBtn = '<div class="prev"><i class="icon-arrowback"></i></div>';
  const nextBtn = '<div class="next"><i class="icon-arrowright"></i></div>';

  if (('[js-flex-slider]').length) {
    $('[js-flex-slider]').slick({
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      mobileFirst: true,
      nextArrow: nextBtn,
      prevArrow: prevBtn,
      speed: 700,
      cssEase: 'cubic-bezier(0.02, 0.31, 0.32, 0.99)',
      responsive: [{
        breakpoint: 960,
        settings: {
          autoplay: true,
          autoplaySpeed: 4000
        }
      }]
    });

    $.fn.clickToggle = function (func1, func2) {
      var funcs = [func1, func2];
      this.data('toggleclicked', 0);
      this.click(function () {
        var data = $(this).data();
        var tc = data.toggleclicked;
        $.proxy(funcs[tc], this)();
        data.toggleclicked = (tc + 1) % 2;
      });
      return this;
    };

    $('.pause').clickToggle(function () {
      $('[js-flex-slider]').slick('slickPause');
      $(this).toggleClass("play");

    }, function () {
      $('[js-flex-slider]').slick('slickPlay');
      $(this).toggleClass("play");
    });
  }

  let cardsSlider = $('[js-cards-slider]');

  if (cardsSlider.length) {

    let sliderDelay = cardsSlider.data('sliderDelay');

    cardsSlider.slick({
      slidesToShow: 1.2,
      slidesToScroll: 1,
      infinite: false,
      mobileFirst: true,
      nextArrow: nextBtn,
      prevArrow: prevBtn,
      cssEase: 'cubic-bezier(0.02, 0.31, 0.32, 0.99)',
      autoplay: true,
      autoplaySpeed: sliderDelay ? sliderDelay : 4000,
      responsive: [
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    });
  }
});
